import React from "react";

import { Box, Button, TextField, Typography } from "@material-ui/core";
import { fade, makeStyles } from "@material-ui/core/styles";

const ACTION_LABELS = {
  won: "Marcar como ganho",
  lost: "Marcar como perdido",
  open: "Reabrir negocio",
};

const useStyles = makeStyles((theme) => ({
  root: {
    margin: theme.spacing(0, 2, 2),
    padding: theme.spacing(1.5),
    border: `1px solid ${fade(theme.palette.primary.main, 0.32)}`,
    borderRadius: 8,
    backgroundColor: fade(theme.palette.primary.main, 0.045),
  },
  title: {
    fontWeight: 600,
  },
  description: {
    marginTop: theme.spacing(0.5),
    color: theme.palette.text.secondary,
  },
  field: {
    marginTop: theme.spacing(1.25),
  },
  errorSlot: {
    minHeight: 20,
    marginTop: theme.spacing(0.5),
  },
  error: {
    color: theme.palette.error.main,
    fontSize: "0.75rem",
  },
  actions: {
    display: "flex",
    justifyContent: "flex-end",
    gap: theme.spacing(1),
  },
}));

const DealOutcomePanel = ({
  status,
  lossReason,
  saving,
  error,
  onLossReasonChange,
  onCancel,
  onConfirm,
}) => {
  const classes = useStyles();
  const label = ACTION_LABELS[status] || "Alterar status";

  return (
    <Box
      component="form"
      className={classes.root}
      aria-label={label}
      onSubmit={onConfirm}
      noValidate
    >
      <Typography className={classes.title}>{label}</Typography>
      <Typography variant="body2" className={classes.description}>
        {status === "open"
          ? "O fechamento anterior sera removido e o negocio voltara a ficar ativo."
          : `Confirme o novo status do negocio como ${
              status === "won" ? "ganho" : "perdido"
            }.`}
      </Typography>

      {status === "lost" ? (
        <TextField
          className={classes.field}
          fullWidth
          required
          autoFocus
          multiline
          minRows={3}
          disabled={saving}
          variant="outlined"
          size="small"
          label="Motivo da perda"
          value={lossReason}
          error={Boolean(error)}
          inputProps={{ "aria-label": "Motivo da perda" }}
          onChange={(event) => onLossReasonChange(event.target.value)}
        />
      ) : null}

      <Box className={classes.errorSlot} aria-live="polite">
        {error ? <Typography className={classes.error}>{error}</Typography> : null}
      </Box>
      <Box className={classes.actions}>
        <Button onClick={onCancel} disabled={saving}>
          Cancelar
        </Button>
        <Button
          type="submit"
          variant="contained"
          color="primary"
          disabled={saving}
        >
          {saving ? "Salvando..." : "Confirmar"}
        </Button>
      </Box>
    </Box>
  );
};

export default DealOutcomePanel;
